export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string; roles?: string[] }
  modes?: ('fan' | 'organiser')[]
  children?: INavigationRoute[]
  hideFromSidebar?: boolean
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'events',
      displayName: 'menu.events',
      meta: {
        icon: 'music_note',
        roles: ['admin', 'sa', 'user', 'organiser'],
      },
      modes: ['fan'],
    },
    {
      name: 'my-events',
      displayName: 'menu.my-events',
      meta: {
        icon: 'confirmation_number',
        roles: ['admin', 'sa', 'user', 'organiser'],
      },
      modes: ['fan'],
    },
    {
      name: 'managed-events',
      displayName: 'menu.managed-events',
      meta: {
        icon: 'edit_calendar',
        roles: ['admin', 'sa', 'organiser'],
      },
      modes: ['organiser'],
    },
    {
      name: 'all-events',
      displayName: 'menu.all-events',
      meta: {
        icon: 'list',
        roles: ['admin', 'sa'],
      },
      modes: ['organiser'],
    },
    {
      name: 'organiser-help',
      displayName: 'menu.organiser-help',
      meta: {
        icon: 'help_outline',
        roles: ['admin', 'sa', 'organiser'],
      },
      modes: ['organiser'],
    },
    {
      name: 'streaming-help',
      displayName: 'menu.streaming-help',
      meta: {
        icon: 'cast',
        roles: ['admin', 'sa', 'organiser'],
      },
      modes: ['organiser'],
      hideFromSidebar: true,
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
        roles: ['sa'],
      },
    },
    {
      name: 'about',
      displayName: 'menu.about',
      meta: {
        icon: 'info',
        roles: ['admin', 'sa', 'user', 'organiser'],
      },
    },
  ] as INavigationRoute[],
}
